// Generated by CoffeeScript 2.7.0
import Admin__YetAnotherWorkflow__FieldsController from './fields.js';

import Admin__YetAnotherWorkflow__GraphsController from './graphs.js';

import Admin__YetAnotherWorkflow__FlowsController from './flows.js';

import Admin__YetAnotherWorkflow__JourneysController from './journeys.js';

import Admin__YetAnotherWorkflow__SettingsController from './settings.js';

Skylark.App.Controllers.register({Admin__YetAnotherWorkflow__FieldsController, Admin__YetAnotherWorkflow__GraphsController, Admin__YetAnotherWorkflow__FlowsController, Admin__YetAnotherWorkflow__JourneysController, Admin__YetAnotherWorkflow__SettingsController});
